import { useQuery } from '@tanstack/react-query';
import { useAuth } from '~/app/auth/context/AuthContext';
import { OrganizationService } from '~/app/services/organization/organization.service';

export function useEffectiveOrganizationName(organizationId: string): string {
  const { user } = useAuth();
  const isCallerOrganization = user?.organizationId === organizationId;
  const cachedName = isCallerOrganization ? user?.organizationName : undefined;

  const { data } = useQuery({
    queryKey: ['organization', organizationId, 'name'],
    queryFn: () => OrganizationService.findOrganizationById(organizationId),
    enabled: Boolean(organizationId) && !cachedName,
  });

  return cachedName ?? data?.name ?? '—';
}
